// extracted by mini-css-extract-plugin
export default {"spinner":"spinner---Z20ld","bounce1":"bounce1---KfYch","bounce2":"bounce2---PuPBR","sk-bouncedelay":"sk-bouncedelay---qPfbj"};